/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { ClaimsService } from '../../services/claims/claims.service';

@Component({
  selector: 'app-timely-filing-report',
  templateUrl: './timely-filing-report.component.html',
  styleUrls: ['./timely-filing-report.component.css'],
})
export class TimelyFilingReportComponent implements OnInit {
  @Input() claimId: string;
  @Input() reportId: string;
  @Input() renderingNpi: string;
  @Input() billingProviderFirstname: string;
  @Input() billingNpi: string;
  @Input() billingTaxId: string;
  @Input() carrierProcessDate: string;

  claimData: any;
  currentDate: string = new Date().toLocaleDateString('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
  });

  constructor(
    private activeModal: NgbActiveModal,
    private claimService: ClaimsService,
  ) {}

  ngOnInit(): void {
    if (this.claimId) {
      this.claimService
        .getClaimDemographics(this.claimId, this.reportId)
        .subscribe((data) => {
          this.claimData = data;
        });
    }
  }

  close() {
    this.activeModal.dismiss();
  }

  printReceipt(): void {
    window.print();
  }
}
